import React, { useEffect } from "react";
import { init } from "ityped";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const Homepage = ({ isAuthenticated }) => {
  useEffect(() => {
    const myElement = document.querySelector("#main-animate");
    init(myElement, {
      showCursor: false,
      loop: false,
      strings: [
        "Develop your coding and Interview Skills to the Full Potential",
      ],
    });
  }, []);
  if (isAuthenticated) {
    return <Redirect to='/problems' />;
  }
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-10 mx-auto'>
            <div className='row'>
              <div
                className='col-md-6 col-sm-12 order-md-1 order-2 col-12 pt-5  basic-info para'
                data-aos='fade-up'
              >
                <p className=''>Take your skills to next level</p>
                <h2 id='main-animate'></h2>
                <div className='tagline pb-4'>
                  Learn code is one of the highly used website for coding
                  challenges and interview preparation
                </div>
                <Link to='/register' className='btn-basic'>
                  Register/Signin
                </Link>
              </div>
              <div
                className='col-lg-6 order-md-2 order-1 '
                data-aos='fade-down'
              >
                <img
                  src={require("../images/code1.svg")}
                  alt='pcguy'
                  className='img'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row subdetails'>
          <div className='col-10 mx-auto'>
            <hr />
            <h2 className='pt-5 col-lg-8 mx-auto' data-aos='zoom-in'>
              Improve your coding skills with library of 500+ challenges .
            </h2>
            <Link to='/register'>
              <button className='btn-basic mt-4'>View challenges -></button>
            </Link>
            <h3 className='mt-4 pt-4'>Be a part of our family</h3>
            <p className='mt-4 pt-4'>Get Your Dream Job </p>
            <div className='company mt-5 ' data-aos='zoom-in'>
              <img
                src={require("../images/Amazon.svg")}
                style={{ marginTop: "2rem" }}
                alt='amazon'
              />
              <img src={require("../images/Infosys.svg")} alt='infosys' />
              <img src={require("../images/Tata.svg")} alt='Tata' />
            </div>
          </div>
        </div>

        <div className='row newdetails'>
          <div className='col-10 mx-auto'>
            <hr />
            <div className='row'>
              <div className='col-md-6 my-auto' data-aos='fade-up'>
                <h2>LearnCode</h2>
                <p>Supported with over 24 languages .</p>
              </div>
              <div className='col-md-6' data-aos='fade-down'>
                <img
                  src={require("../images/code.svg")}
                  alt='imge'
                  className='img1'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-10 mx-auto'>
            <hr />
            <div className='info-container pt-5'>
              <div className='col-md-6' data-aos='fade-up'>
                <img
                  src={require("../images/proud.svg")}
                  className='img1'
                  alt='undraw'
                />
              </div>
              <div className='col-md-6 my-auto bullet' data-aos='fade-down'>
                <h3 className='my-5'>Be a Better Developer</h3>
                <p>
                  <img src={require("../images/Vector.png")} alt='v' /> Practice
                  with Challenges
                </p>
                <p>
                  <img src={require("../images/chat.png")} alt='v1' />
                  Follow our Interview Preparation Kit
                </p>
                <p>
                  <img src={require("../images/grp.png")} alt='v2' />
                  Discuss with community and Learn
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Homepage.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Homepage);
